import { LBtn } from "@components";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { useModal } from "@services/ModalContext";

export const ExistingFooter = ({ loading, onBeginAssessment }: ExistingFooterProps): JSX.Element => {
    const { onConfirm, formName } = useModal();
    const { isFacilitator } = useUserPermission({ useCurrentLocation: true });

    return (
        <div className="is-flex is-flex-direction-row is-justify-content-center">
            <LBtn variation="unstyled" onClick={onConfirm} isBold>
                Save to Upcoming
            </LBtn>
            {isFacilitator && (
                <LBtn type="submit" form={formName} isBold loading={loading} onClick={onBeginAssessment}>
                    Begin Assessment
                </LBtn>
            )}
        </div>
    );
};

interface ExistingFooterProps {
    loading?: boolean;
    onBeginAssessment?: () => void;
}
